import config from '@constants/config';

export const TELEGRAM_LINK = config.telegramLink;
